module.exports = __webpack_public_path__ + "img/_m6oldcup.prt.ce09ea66.jpg";